export function getCookie(name) {
    if (!name) return undefined;

    const cookies = document.cookie ? document.cookie.split("; ") : [];

    for (let i = 0; i < cookies.length; i++) {
        const [key, ...rest] = cookies[i].split("=");
        if (key === name) {
            return decodeURIComponent(rest.join("="));
        }
    }

    return undefined;
}

export function setCookie(name, value, options = {}) {
    if (!name) return;

    const {
        days = 365,
        path = "/",
        domain,
        secure = window.location.protocol === "https:",
        sameSite = "Lax"
    } = options;

    let cookie = `${name}=${encodeURIComponent(value)}`;

    if (typeof days === "number") {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        cookie += `; expires=${expires.toUTCString()}`;
    }

    if (path) {
        cookie += `; path=${path}`;
    }

    if (domain) {
        cookie += `; domain=${domain}`;
    }

    if (secure) {
        cookie += `; secure`;
    }

    if (sameSite) {
        cookie += `; samesite=${sameSite}`;
    }

    document.cookie = cookie;
}